import { cachedAxios } from '../services/cache/CachedAxios';
import { Token } from '../types/wallet';

const FIN_SERVICE_URL = process.env.REACT_APP_FIN_SERVICE_URL;

export async function getSolBalance(address: string): Promise<number | null> {
  try {
    const response = await cachedAxios.get<{ balance: number }>(
      `${FIN_SERVICE_URL}/blockchain/get-balance?wallet=${address}&type=sol`
    );
    return response.balance;
  } catch (e) {
    console.error('Error in solBalance', e);
    return null;
  }
}

async function getTokenBalances(address: string): Promise<Token[]> {
  try {
    const response = await cachedAxios.get<{ tokens: any[] }>(
      `${FIN_SERVICE_URL}/blockchain/get-token-balances?wallet=${address}&type=sol`
    );

    console.log('Raw token data from API:', JSON.stringify(response.tokens, null, 2));

    const tokens = response.tokens.map((token: any) => {
      console.log('Processing token:', {
        symbol: token.symbol,
        name: token.name,
        mint: token.mint,
        amount: token.amount,
        raw: token,
        hasPool: token.hasPool,
        liquidity: token.liquidity,
      });
      return {
        ...token
      };
    });

    console.log('Processed tokens:', JSON.stringify(tokens, null, 2));
    return tokens;
  } catch (e) {
    console.error('Error in tokens', e);
    return [];
  }
}

export async function getTokenPrice(tokenNames: string): Promise<any[]> {
  try {
    const response = await cachedAxios.get<any[]>(
      `${FIN_SERVICE_URL}/market/price?names=${tokenNames}&currency=usd`
    );
    return response;
  } catch (e) {
    console.error('Error in prices', e);
    return [];
  }
}

async function getTokenPriceByAddress(addresses: string): Promise<any[]> {
  const chunkSize = 150;
  const allResults: { address: string; price: number; }[] = [];

  const addressArray = addresses.split(',').map((addr) => addr.trim());

  try {
    for (let i = 0; i < addressArray.length; i += chunkSize) {
      const chunk = addressArray.slice(i, i + chunkSize);
      const chunkAddresses = chunk.join(',');
      const response = await cachedAxios.get<any[]>(
        `${FIN_SERVICE_URL}/market/price-by-address?address=${chunkAddresses}&chain=solana&currency=usd`
      );
      allResults.push(...response);
    }

    return allResults;
  } catch (e) {
    console.error('Error in prices', e);
    return [];
  }
}

export async function getWalletBalances(address: string): Promise<{ address: string; balance: number; tokens: Token[] }> {
  // 2. Получаем балансы SPL-токенов
  const tokens = await getTokenBalances(address);

  const allTokens: Token[] = [
    ...tokens
  ];

  const addresses = allTokens.map(token => token.mint).join(',');

  const prices = await getTokenPriceByAddress(addresses);

  const updatedTokens = allTokens.map(token => {
    const priceData = prices.find((price: any) => price.address === token.mint);
    return {
      ...token,
      usdValue: priceData ? priceData.price * token.amount : 0
    };
  });

  const totalUsdValue: number = updatedTokens.reduce((acc, token) => acc + token.usdValue, 0);

  return {
    address,
    balance: totalUsdValue,
    tokens: updatedTokens,
  };
}
